import React, { createContext, useContext, useEffect, useState } from 'react'


const NetworkContext  = createContext();


export const  NetworkProvider = ({children})=> {
    const [isOnline , setIsOnline]= useState(navigator.onLine);
    useEffect(()=>{
      function updateNetworkStatus(){
        setIsOnline(navigator.onLine);
      }
      window.addEventListener("online",updateNetworkStatus);
      window.addEventListener("offline", updateNetworkStatus);
      return() =>{
        window.removeEventListener("online", updateNetworkStatus);
        window.removeEventListener("offline", updateNetworkStatus);
      }
    },[]);

    return (
      <NetworkContext.Provider value={{isOnline}}>
        {children}
      </NetworkContext.Provider>
    )
}

export const useNetworkStatus = ()=> useContext(NetworkContext);